import { makeStyles } from '@material-ui/core/styles'

export const itServiceCenterStyles = makeStyles((theme) => ({
  content: {
    padding: 0,
  },
  mainGrid: {
    display: 'flex',
  },
  scrollContent: {
    flex: 1,
    minHeight: '1px',
    overflowY: 'auto',
    overflowX: 'hidden',
  },
  input: {
    color: theme.palette.base.white,
  },
  iconName: {
    color: theme.palette.base.white,
  },
  searchBar: {
    margin: theme.spacing(0, 1, 0.5, 1),
  },
  imgContainer: {
    margin: '3px 0px',
    justifyContent: 'center',
  },
  img: {
    height: 35,
    width: 'auto',
    padding: 5,
  },
  modalTabs: {
    width: 335,
    height: 35,
    [theme.breakpoints.down(400)]: {
      width: 300,
    },
  },
  tabPanel: {
    width: '100%',
    height: 262,
    maxHeight: 262,
    [theme.breakpoints.down(769)]: {
      height: 'calc(100dvh - 412px)',
    },
  },
  announcementList: {
    width: '100%',
    height: '100%',
    overflow: 'clip',
    overflowY: 'auto',
    padding: theme.spacing(1),
  },
  casesList: {
    width: '100%',
    height: 'calc(100% - 34px)',
    overflow: 'clip',
    overflowY: 'auto',
    padding: theme.spacing(1),
  },
  bottomContainer: {
    width: '100%',
  },
  grid1: {
    display: 'flex',
    justifyContent: 'space-around',
    height: '40px',
    backgroundColor: theme.palette.base.blueGray,
  },
  icon: {
    color: theme.palette.base.white,
    width: '100%',
    fontSize: 25,
    '&:hover': {
      transform: 'scale(1.07)',
    },
  },
  tabLink: {
    position: 'relative',
    fontSize: '10px',
    color: 'white',
    bottom: 4,
  },
  tabBackground: {
    width: '100%',
    height: 35,
    backgroundColor: theme.palette.backgroundColor.secondary,
  },
  tabTextLabel: {
    fontSize: 14,
  },
  circleIcon: {
    fontSize: 70,
    color: theme.palette.base.green,
  },
  linkContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '4px 4px 0px 4px',
    '&:focus-visible': {
      outline: `1px solid ${theme.palette.button.focusBorder}`,
      boxShadow: `0 0 0 3px ${theme.palette.button.focusOutline}`,
      backgroundColor: 'rgba(255, 255, 255, 0.21)',
      borderRadius: '4px',
    },
    '&:hover': {
      backgroundColor: 'rgba(255, 255, 255, 0.21)',
      borderRadius: '4px',
    },
  },
  tinyText: {
    fontSize: '10px',
    marginTop: '6.5px',
  },
  footerLink: {
    width: '100%',
    textAlign: 'center',
    '&:hover': {
      cursor: 'pointer',
      textDecoration: 'none',
    },
  },
  footerText: {
    lineHeight: 1.3,
    padding: theme.spacing(0, 4),
  },
}))

export const AnnouncementObjectStyles = makeStyles((theme) => ({
  gridItem: {
    width: '100%',
  },
  announcementCardBackground: {
    height: 'auto',
    padding: theme.spacing(1, 2),
    margin: theme.spacing(0.5, 0),
    width: '100%',
  },
}))

export const MyCasesObjectStyles = makeStyles((theme) => ({
  gridItem: {
    width: '100%',
  },
  caseCardBackground: {
    height: 'auto',
    padding: theme.spacing(1, 2),
    margin: theme.spacing(0.5, 0),
    width: '100%',
  },
  caseIDTextOpen: {
    width: '100%',
    textAlign: 'left',
    color: theme.palette.base.green,
  },
  caseIDTextClosed: {
    width: '100%',
    textAlign: 'left',
    color: theme.palette.base.red,
  },
  iconButton: {
    position: 'relative',
    right: 5,
    padding: 0,
    paddingBottom: 5,
    '&:hover': {
      backgroundColor: 'transparent',
    },
  },
  expandOpen: {
    textAlign: 'left',
    transform: 'rotate(0deg)',
    transition: theme.transitions.create('transform', {
      duration: theme.transitions.duration.shortest,
    }),
  },
  expandClosed: {
    justifyContent: 'left',
    textAlign: 'left',
    transform: 'rotate(180deg)',
  },
  caseDescription: {
    color: theme.palette.primary.headerText,
    width: 270,
    textAlign: 'left',
    [theme.breakpoints.down(769)]: {
      width: 240,
    },
  },
  descriptionText: {
    width: 270,
    wordWrap: 'break-word',
    overflowWrap: 'break-word !important',
    display: 'inline-block',
    [theme.breakpoints.down(769)]: {
      width: 240,
    },
  },
}))

export const ToDoObjectStyles = makeStyles((theme) => ({
  gridItem: {
    width: '100%',
    marginTop: '-5px',
  },
  caseCardBackground: {
    height: 'auto',
    padding: theme.spacing(1, 2),
    margin: theme.spacing(0.5, 0),
    width: '100%',
  },
  linkStyle: {
    marginBottom: '-5px',
  },
  greenText: {
    color: theme.palette.base.green,
  },
  greenIcon: {
    marginLeft: 13,
    color: theme.palette.base.green,
  },
  yellowText: {
    color: theme.palette.base.orange,
  },
  yellowIcon: {
    marginLeft: 13,
    color: theme.palette.base.orange,
  },
}))
